import { Component, Input } from '@angular/core';
import { PrinterStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-printer-status-indicator',
    templateUrl: './printer-status-indicator.component.html',
    styleUrls: ['./printer-status-indicator.component.scss'],
    standalone: false,
})
export class PrinterStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() printer: PrinterStatus;

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.printer) > 0;
    }

    getIcon(alarmValue: 0 | 1): string {
        if (!this.isReceivingData) return '';
        if (alarmValue === 0) {
            return 'status-error';
        } else if (alarmValue === 1) {
            return 'status-check';
        }
    }
}
